var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBentArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "51px",
    viewBox: "0 0 29 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(681.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.990271,49.8928561 L28.249315,29.9250682 C29.052118,28.5867447 28.0887162,26.8734993 26.5360697,26.8734993 L20.3799724,26.8734993 L20.3799724,18.8435578 C20.3799724,8.4581668 11.9217673,-3.82378166e-05 1.53637635,-3.82378166e-05 C0.198052771,-3.82378166e-05 -0.497971086,1.60604565 0.411993355,2.56944744 L2.66037697,4.9783343 C6.24708417,8.88614356 8.22761188,13.9716776 8.22761188,19.2716301 L8.22761188,26.8198707 L2.01845963,26.8198707 C0.46619546,26.8198707 -0.497588708,28.5331161 0.305214252,29.8714397 L12.5642583,49.8392275 C13.3674436,51.1775511 15.2409054,51.1775511 15.990749,49.8930473 L15.990271,49.8928561 Z",
    fill: "#888"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBentArrow);
export default __webpack_public_path__ + "static/media/bent-arrow.c6abe9c1c61a7ad0c4253f0fd94f297f.svg";
export { ForwardRef as ReactComponent };